var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.invoice.invoice_id)?_c('div',[_c('ViewSale2',{attrs:{"viewdata":_vm.invoice}})],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-545d9c15","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sales/ViewSaleWrapper.vue
// module id = null
// module chunks = 